import type { ReactNode } from "react";
import { Info } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

/**
 * Ícone de ajuda discreto com explicação. Acessível por mouse (clique), teclado (foco + Enter/Espaço) e
 * toque (tap) — via Popover do Radix. Use nos cabeçalhos para explicar a origem/formação de cada valor.
 */
export function InfoHint({ label, children }: { label: string; children: ReactNode }) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label={`Ajuda: ${label}`}
          className="ml-1 inline-flex items-center align-middle rounded text-muted-foreground transition-colors hover:text-foreground focus:outline-none focus-visible:ring-1 focus-visible:ring-ring"
        >
          <Info className="h-3 w-3" aria-hidden="true" />
        </button>
      </PopoverTrigger>
      <PopoverContent side="top" align="start" className="max-w-xs text-xs font-normal leading-relaxed">
        <div className="mb-1 font-semibold">{label}</div>
        <div className="text-muted-foreground">{children}</div>
      </PopoverContent>
    </Popover>
  );
}
